import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { CountryDataForm, CountryFilters } from '../../models/Country';

const useCountryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetCountries, setFetchingGetCountries] = useState(false);
    const [fetchingStoreCountry, setFetchingStoreCountry] = useState(false);
    const [fetchingEditCountry, setFetchingEditCountry] = useState(false);
    const [fetchingUpdateCountry, setFetchingUpdateCountry] = useState(false);
    const [fetchingDeleteCountry, setFetchingDeleteCountry] = useState(false);
    const [fetchingActiveCountry, setFetchingActiveCountry] = useState(false);

    const getCountries = (filter: CountryFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .filter(([, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.COUNTRY.GET_COUNTRIES}?${queryString}`;
        doGet({
            ...events,
            url,
            setFetching: setFetchingGetCountries
        });
    };

    const storeCountry = (country: CountryDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.COUNTRY.STORE_COUNTRY,
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            requestType: 'json',
            body: country,
            setFetching: setFetchingStoreCountry
        });
    };

    const editCountry = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.COUNTRY.EDIT_COUNTRY.replace(':id', id.toString()),
            setFetching: setFetchingEditCountry
        });
    };

    const updateCountry = (id: number, country: CountryDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.COUNTRY.UPDATE_COUNTRY.replace(':id', id.toString()),
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            requestType: 'json',
            body: country,
            setFetching: setFetchingUpdateCountry
        });
    };

    const deleteCountry = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.COUNTRY.DELETE_COUNTRY.replace(':id', id.toString()),
            setFetching: setFetchingDeleteCountry
        });
    };

    const activeCountry = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.COUNTRY.ACTIVE_COUNTRY.replace(':id', id.toString()),
            body: { active },
            setFetching: setFetchingActiveCountry
        });
    };

    return {
        fetchingGetCountries,
        fetchingStoreCountry,
        fetchingEditCountry,
        fetchingUpdateCountry,
        fetchingDeleteCountry,
        fetchingActiveCountry,
        getCountries,
        storeCountry,
        editCountry,
        updateCountry,
        deleteCountry,
        activeCountry
    };
};

export default useCountryService;
